import { Button } from '@iwoca/orion';
import { useFormContext, useWatch } from 'react-hook-form';

import { HookFormCheckbox } from '../../../../Buyer/components/Checkbox/Checkbox';
import { Policy } from '../../../../Buyer/Signup/steps/DirectorInfo/Policy/Policy';
import { LoadingSpinner } from '../../../../components/LoadingSpinner/LoadingSpinner';
import { CrossSellFormValues } from '../../utils/CrossSellCard.types';

export const PrivacyPolicy = () => {
  const {
    control,
    formState: { isValid, isSubmitting },
  } = useFormContext<CrossSellFormValues>();
  const policyAgreed = useWatch({ control, name: 'policyAgreed' });

  return (
    <div>
      <div className="max-h-[350px] overflow-y-scroll bg-secondary-95 px-s">
        <Policy />
      </div>
      <HookFormCheckbox
        disabled={isSubmitting}
        name="policyAgreed"
        labelText="I'm happy with this"
        className="my-l"
      />
      <Button
        type="submit"
        defaultChecked={policyAgreed}
        disabled={!isValid || isSubmitting}
        className="w-full"
      >
        {isSubmitting ? (
          <>
            <div className="mr-s">Submitting...</div>
            <LoadingSpinner />
          </>
        ) : (
          'Submit Application'
        )}
      </Button>
    </div>
  );
};
